module.exports = __webpack_public_path__ + "img/tradestation.0fce82dd.png";